var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2587 0.808056L7.47671 6.59006L1.69471 0.808056C1.50611 0.625897 1.25351 0.525103 0.991311 0.527382C0.729114 0.52966 0.478301 0.634829 0.292893 0.820237C0.107485 1.00564 0.00231622 1.25646 3.78026e-05 1.51865C-0.00224062 1.78085 0.0985537 2.03345 0.280712 2.22206L6.76671 8.70806C6.85972 8.80146 6.97041 8.87539 7.09232 8.92552C7.21423 8.97566 7.3449 9.001 7.47671 9.00006C7.60848 9.00072 7.73908 8.97525 7.86094 8.92513C7.98281 8.87501 8.09353 8.80123 8.18671 8.70806L14.6727 2.22206C14.8549 2.03345 14.9557 1.78085 14.9534 1.51865C14.9511 1.25646 14.8459 1.00564 14.6605 0.820237C14.4751 0.634829 14.2243 0.52966 13.9621 0.527382C13.6999 0.525103 13.4473 0.625897 13.2587 0.808056Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5f25ba5ef24bf551b18466ec5d64ad2b.svg";
export { ForwardRef as ReactComponent };